import { render, staticRenderFns } from "./TrucksPage.vue?vue&type=template&id=50b0c58e"
import script from "./TrucksPage.vue?vue&type=script&lang=js"
export * from "./TrucksPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports